var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ProductQuantitySelectorAxb } from "./ProductQuantitySelectorAxb";
import Model from "../Model";
var ProductQuantitySelector = /** @class */ (function (_super) {
    __extends(ProductQuantitySelector, _super);
    function ProductQuantitySelector(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.axb = [];
        _this._isProductUniquable = false;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        ProductQuantitySelector.buildFromJson(_this, obj);
        return _this;
    }
    Object.defineProperty(ProductQuantitySelector.prototype, "isProductUniquable", {
        get: function () {
            return this._isProductUniquable;
        },
        set: function (value) {
            if (value) {
                this.set_quantity_uniquable_compat();
            }
            this._isProductUniquable = value;
        },
        enumerable: false,
        configurable: true
    });
    ProductQuantitySelector.prototype.set_quantity_uniquable_compat = function () {
        for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
            var axb = _a[_i];
            axb.step = 0;
            axb.min = 1;
            axb.max = 1;
        }
    };
    ProductQuantitySelector.prototype.set_quantity_default = function () {
        this.isProductUniquable = false;
        for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
            var axb = _a[_i];
            axb.step = 1;
            axb.min = 0;
            axb.max = null;
        }
    };
    Object.defineProperty(ProductQuantitySelector.prototype, "minQuantity", {
        get: function () {
            var min = -1;
            for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
                var axb = _a[_i];
                if (min === -1 || axb.min < min) {
                    min = parseInt("" + axb.min);
                }
            }
            return min !== -1 ? min : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductQuantitySelector.prototype, "maxQuantity", {
        get: function () {
            var max = null;
            for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
                var axb = _a[_i];
                if (axb.max !== null) {
                    if (max === null) {
                        max = parseInt("" + axb.max);
                    }
                    else if (axb.max > max) {
                        max = parseInt("" + axb.max);
                    }
                }
            }
            return max;
        },
        enumerable: false,
        configurable: true
    });
    ProductQuantitySelector.prototype.get_next_quantity = function (value, debug) {
        if (debug === void 0) { debug = false; }
        var next_quantity = null;
        for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
            var axb = _a[_i];
            if (next_quantity === null || axb.get_next_quantity(value) < next_quantity) {
                next_quantity = axb.get_next_quantity(value);
            }
        }
        if (debug && next_quantity === value) {
            console.warn("La valeur maximale est atteinte.");
        }
        if (next_quantity !== null) {
            return next_quantity;
        }
        else {
            return value;
        }
    };
    ProductQuantitySelector.prototype.get_previous_quantity = function (value, debug) {
        if (debug === void 0) { debug = false; }
        var previous_quantity = null;
        for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
            var axb = _a[_i];
            if (previous_quantity === null || axb.get_previous_quantity(value) > previous_quantity) {
                previous_quantity = axb.get_previous_quantity(value);
            }
        }
        if (debug && previous_quantity === value) {
            console.warn("La valeur maximale est atteinte.");
        }
        if (previous_quantity !== null) {
            return previous_quantity;
        }
        else {
            return value;
        }
    };
    /** Quantity **/
    ProductQuantitySelector.buildFromJson = function (instance, json) {
        if (typeof json === 'object') {
            for (var prop in json) {
                if (prop === 'axb' && json[prop].length > 0) {
                    for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                        var subProp = _a[_i];
                        instance.axb.push(new ProductQuantitySelectorAxb(subProp));
                    }
                }
                else if (prop === 'isProductUniquable') {
                    instance[prop] = instance._isProductUniquable = json[prop];
                }
                else {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    ProductQuantitySelector.prototype.exportToJson = function () {
        var JSONQtySelector = {};
        JSONQtySelector.isProductUniquable = this._isProductUniquable;
        JSONQtySelector.axb = [];
        if (this.axb.length === 0) {
            this.axb.push(new ProductQuantitySelectorAxb());
        }
        if (this.axb.length > 0) {
            for (var qty in this.axb) {
                JSONQtySelector.axb.push(this.axb[qty].exportToJson());
            }
        }
        return JSONQtySelector;
    };
    ProductQuantitySelector.prototype.add_axb = function (options) {
        this.axb.push(new ProductQuantitySelectorAxb(options));
    };
    ProductQuantitySelector.prototype.is_quantity_allowed = function (quantity, debug) {
        for (var _i = 0, _a = this.axb; _i < _a.length; _i++) {
            var axb = _a[_i];
            if (axb.isQuantityAllowed(quantity, { debug: debug })) {
                return true;
            }
        }
        if (debug) {
            if (this.axb.length === 0) {
                console.warn("axb.length=0\n", "File : GroupItem.ts\n", "Object : ProductQuantitySelector\n", "Function : is_quantity_allowed()\n");
                console.group("Détail de l'objet en cours");
                console.warn(this);
                console.group("Détail de l'objet");
                console.warn(this.axb);
                console.groupEnd();
                console.groupEnd();
            }
            else {
                console.warn("Quantity is not allowed\n", "File : GroupItem.ts\n", "Object : ProductQuantitySelector\n", "Function : is_quantity_allowed()\n");
            }
        }
        return false;
    };
    return ProductQuantitySelector;
}(Model));
export { ProductQuantitySelector };
//# sourceMappingURL=ProductQuantitySelector.js.map